// 培训管理
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

/**
 * 培训管理
 */

// 培训管理列表
export function getTrainList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/trains',
    params: parameter,
    method: 'GET'
  })
}

// 新增和修改培训
export function controlTrain (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/train',
    data: parameter,
    method: 'POST'
  })
}

// 删除培训
export function deleteTrain (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/trains',
    params: parameter,
    method: 'DELETE'
  })
}

// 发布培训
export function releaseTrain (id) {
  return axios({
    url: sysInfo.apiRemote + `/train/release/${id}`,
    method: 'PUT'
  })
}

// 撤回培训
export function backTrain (id) {
  return axios({
    url: sysInfo.apiRemote + `/train/back/${id}`,
    method: 'PUT'
  })
}

// 培训进度
export function getTrainProgress (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/train/progress',
    params: parameter,
    method: 'GET'
  })
}

// 批量确认成绩
export function confirmTrainExams (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/train/exams/confirm',
    data: parameter,
    method: 'POST'
  })
}

// 查看试卷
export function viewTrainExams (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/train/exam',
    params: parameter,
    method: 'GET'
  })
}

// 修改题目分析
export function updateSubjectRemark (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/subject/remark',
    data: parameter,
    method: 'PUT'
  })
}

// 修改导师点评
export function updateExamRemark (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/train/exam/remark',
    data: parameter,
    method: 'PUT'
  })
}

// 单个确认成绩
export function confirmTrainExamsSingle (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/train/exam/confirm',
    data: parameter,
    method: 'POST'
  })
}

/**
 * 课程管理
 */

// 课程列表
export function getCourseList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/courses',
    params: parameter,
    method: 'GET'
  })
}

// 新增&修改课程
export function controlCourse (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/course',
    data: parameter,
    method: 'POST'
  })
}

// 删除课程
export function deleteCourse (id) {
  return axios({
    url: sysInfo.apiRemote + `/course/${id}`,
    method: 'DELETE'
  })
}

// 发布课程
export function releaseCourse (id) {
  return axios({
    url: sysInfo.apiRemote + `/course/release/${id}`,
    method: 'PUT'
  })
}

// 撤回课程
export function backCourse (id) {
  return axios({
    url: sysInfo.apiRemote + `/course/back/${id}`,
    method: 'PUT'
  })
}

// 考试设置
export function configCourseExam (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/course/exam`,
    data: parameter,
    method: 'POST'
  })
}

// 单个课程完整信息
export function getCourseDetail (id) {
  return axios({
    url: sysInfo.apiRemote + `/course/${id}`,
    method: 'GET'
  })
}

// 下载课程的文件
export function downLoadCourseFile (filePath) {
  return axios({
    url: sysInfo.apiRemote + `/course/files/${filePath}`,
    method: 'GET',
    responseType: 'blob',
    timeout: 5 * 60 * 1000
  })
}

/**
 * 题库管理
 */

// 获取题库列表
export function getSubjectBanks (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/subject/banks',
    params: parameter,
    method: 'GET'
  })
}

// 新增和修改题库
export function controlSubjectBanks (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/subject/bank',
    data: parameter,
    method: 'POST'
  })
}

// 删除题库
export function deleteSubjectBanks (id) {
  return axios({
    url: sysInfo.apiRemote + `/subject/bank/${id}`,
    method: 'DELETE'
  })
}

// 题目列表
export function getSubjects (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/subjects',
    params: parameter,
    method: 'GET'
  })
}

// 新增&修改题目信息
export function controlSubjectsDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/subject`,
    data: parameter,
    method: 'POST'
  })
}

// 获取单个题目信息
export function getSubjectsDetail (id) {
  return axios({
    url: sysInfo.apiRemote + `/subject/${id}`,
    method: 'GET'
  })
}

// 题库下题目类型集合接口
export function getSubjectInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/subject/bank/types`,
    params: parameter,
    method: 'GET'
  })
}

// 批量删除题目
export function deleteSubjects (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/subject`,
    params: parameter,
    method: 'DELETE'
  })
}

// 模板下载
export function downloadSubjects () {
  return axios({
    url: sysInfo.apiRemote + `/download/template?fileName=exampaper_template.xlsx`,
    responseType: 'blob',
    method: 'GET'
  })
}

// 批量导入
export function importSubjects (parameter, id) {
  return axios({
    url: sysInfo.apiRemote + `/subjects/import?subjectBankId=${id}`,
    data: parameter,
    timeout: 5 * 60 * 1000,
    method: 'POST'
  })
}

// 批量导出
export function exportSubjects (id) {
  return axios({
    url: sysInfo.apiRemote + `/subjects/export?subjectBankId=${id}`,
    responseType: 'blob',
    timeout: 5 * 60 * 1000,
    method: 'GET'
  })
}

/**
 * 我的培训
 */

// 我的培训列表
export function getPersonTrains (parameter) {
  return axios({
    // url: mockRemote + '/person/trains',
    url: sysInfo.apiRemote + '/person/trains',
    params: parameter,
    method: 'GET'
  })
}

// 学习课件获取
export function getPersonTrainStudy (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/person/train/study',
    params: parameter,
    method: 'GET'
  })
}

// 开始考试
export function getExamInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/person/train/exam',
    params: parameter,
    method: 'GET'
  })
}

// 提交试卷
export function submitExamInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/person/train/exam',
    data: parameter,
    method: 'POST'
  })
}

// 课件学习进度记录保存
export function saveStudyProgess (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/person/train/progress',
    data: parameter,
    method: 'PUT'
  })
}

/**
 * 汇总分析
 */

// 培训情况列表
export function getTrainSummary (parameter) {
  return axios({
    // url: mockRemote + '/train/summary',
    url: sysInfo.apiRemote + '/train/summary',
    params: parameter,
    method: 'GET'
  })
}

// 学员情况列表
export function getUserSummary (parameter) {
  return axios({
    // url: mockRemote + '/train/user/summary',
    url: sysInfo.apiRemote + '/train/user/summary',
    params: parameter,
    method: 'GET'
  })
}

// 考生成绩列表
export function getScoreSummary (parameter, trainId) {
  return axios({
    url: sysInfo.apiRemote + `/train/summary/${trainId}`,
    params: parameter,
    method: 'GET'
  })
}

// 学员分析列表
export function getUserAnalysis (parameter, userId) {
  return axios({
    url: sysInfo.apiRemote + `/train/user/summary/${userId}`,
    params: parameter,
    method: 'GET'
  })
}

// 培训情况导出
export function exportTrainSummary (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/train/export/summary`,
    responseType: 'blob',
    timeout: 5 * 60 * 1000,
    method: 'GET',
    params: parameter
  })
}

// 学员情况导出
export function exportUserSummary (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/train/export/user/summary`,
    timeout: 5 * 60 * 1000,
    method: 'GET',
    params: parameter,
    responseType: 'blob'
  })
}

// 考生成绩导出
export function exportScoreSummary (trainId) {
  return axios({
    url: sysInfo.apiRemote + `/train/export/summary/${trainId}`,
    timeout: 5 * 60 * 1000,
    method: 'GET',
    responseType: 'blob'
  })
}

// 学员分析导出
export function exportUserAnalysis (userId) {
  return axios({
    url: sysInfo.apiRemote + `/train/export/user/summary/${userId}`,
    timeout: 5 * 60 * 1000,
    method: 'GET',
    responseType: 'blob'
  })
}
